import axios from "axios";
import router from "@/router";
import { message, Modal } from "ant-design-vue";

let ModalStatus = "hide";
export const _ctxPath = process.env.VUE_APP_BASE_API;
export const _accept =
  ".bmp, .gif, .png, .jpg, .jpeg, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .txt, .wps, .rar, .zip, .gz, .bz2, .tgz, .tar, .mp3, .avi, rmvb, .pdf, .ofd";

import store from "@/store";
const ajax = axios.create({});
ajax.interceptors.request.use(
  (config) => {
    const token = store.getters.token;
    // const  token = 'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX3R5cGUiOjAsImxvZ2luX3VzZXJfa2V5IjoiLTcyMDk0NjI4NzkxNDc1NzIzMTUifQ.EDWtmQlSVmcYQfO81u_clfiH0sZKzJq0c1wOf8S_JA1QRELhILVlpJ-_RMdmrAEJvNRL6yY2V4mNC2ju3t7UtQ';
    // const  token = 'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX3R5cGUiOjEsImxvZ2luX3VzZXJfa2V5IjoiLTEzNjk1OTc2OTAyMTAwNzE3MjQifQ.poqVEoOPR_MC8tO6fuWOM-kdvSDEZ3wYuWzzSf3hNGXMdsfD3BjYqW2rMuez63M8LxuUt3x16ekfsXbWHq9xFg';
    // const  token = 'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX3R5cGUiOjQsImxvZ2luX3VzZXJfa2V5IjoiLTE4ODY1NzU0ODIxNzI2NzczNyJ9.iZAv2vOL3htfgfSmGHnk7x4ptJ9V7-71mzDyWi9t8NEuRH-39pHYw1QkSBjLnZQkNUW57qJQH-I0AGfKrSdiOQ';
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    return config;
  },
  (err) => {
    console.log(err);
  }
);
ajax.interceptors.response.use(
  (data) => {
    if (
      data.status &&
      data.status == 200 &&
      data.data.code != 0 &&
      data.data.message &&
      !(data.data.status == 0 && data.data.code == "BOOT_0000")
    ) {
      message.error(data.data.message);
    }
    // 导出图片需要header里的东西
    if (data.headers["content-disposition"]) {
      return data;
    }
    if (data.data?.data?.is_complete === 0) {
      store.commit("setComplete", 0);
    }
    if (!data.data.code && !data.data.message && !data.data.data) {
      return data.data;
    }

    return data.data;
  },
  (err) => {
    if (err.response) {
      if (err.response.status == 504 || err.response.status == 404) {
        //alert('服务器被吃了');
      } else if (err.response.status == 401) {
        if (process.env.NODE_ENV != "development") {
          router.push("/guide");
          // window.location.href = process.env.VUE_APP_IXIAMEN_URL;
        }
      } else if (err.response.status === 403) {
        if (ModalStatus === "hide") {
          ModalStatus = "show";
          Modal.warning({
            title: "权限不足",
            content: "您暂无权限操作此页面",
            onOk: function () {
              ModalStatus = "hide";
              history.back();
            },
          });
        }
      }
    } else {
      //alert('未知错误!');
    }
    return false;
  }
);

/**
 *
 * @param {*} param0
 * url请求地址
 * method请求方式
 * data参数
 * isPureText是否流数据
 * isCatchError是否页面内部处理错误信息，默认为false,为false就统一在response处理
 * @returns
 */

const $http = ({
  url,
  method = "get",
  data = {},
  params = {},
  responseType = "application/json",
  isPuretext = false,
  contentType = "application/json",
  // isCatchError = false
}) => {
  const path = `${_ctxPath}${url}`;

  // var path = ''
  // if (url.includes('http')) {
  //   path = url
  // } else {
  //   path = `${_ctxPath}${url}`
  // }

  if (isPuretext) {
    return axios.get(path, { responseType: "text" });
  }
  if (method == "put" || method == "post") {
    if (responseType == "blob") {
      //导出contentType重写
      return ajax({
        method: method,
        url: path,
        data: data,
        params: params,
        responseType: responseType,
        contentType: contentType,
      });
    } else {
      return ajax({
        method: method,
        url: path,
        data: data,
        params: params,
        responseType: responseType,
        headers: {
          "Content-Type": contentType,
        },
      });
    }
  }
  if (method == "get" || method == "delete") {
    if (responseType == "blob") {
      //导出contentType重写
      return ajax({
        method: method,
        url: path,
        params: data || params,
        responseType: responseType,
        contentType: contentType,
      });
    } else {
      return ajax({
        method: method,
        url: path,
        params: data || params,
        headers: {
          "Content-Type": contentType,
        },
      });
    }
  }
};
export default $http;
